/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type carouselTabQueryVariables = {
    readonly listID: string;
};
export type carouselTabQueryResponse = {
    readonly list: {
        readonly hasErrors: boolean | null;
    } | null;
};
export type carouselTabQuery = {
    readonly response: carouselTabQueryResponse;
    readonly variables: carouselTabQueryVariables;
};



/*
query carouselTabQuery(
  $listID: ID!
) {
  list(id: $listID) {
    hasErrors
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "listID",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "list",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "listID"
      }
    ],
    "concreteType": "ListPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "carouselTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "carouselTabQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "carouselTabQuery",
    "id": null,
    "text": "query carouselTabQuery(\n  $listID: ID!\n) {\n  list(id: $listID) {\n    hasErrors\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '3267b8f89d35ff39564719d064b1574b';
export default node;
